import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Box, Button, Image, SimpleGrid, Text, VStack} from '@chakra-ui/react';

const UrlPhotoView = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const urls: string[] = location.state?.urls || [];

    return (
        <Box p={6} bg="#F4F7FE">
            <Button mb={4} onClick={() => navigate(-1)} colorScheme="blue" variant="outline">
                Back to All Summaries
            </Button>

            <VStack spacing={4} align="start">
                <Text fontSize="2xl" fontWeight="bold">Attached Images</Text>
                {urls.length === 0 ? (
                    <Text>No images to display.</Text>
                ) : (
                    <SimpleGrid columns={{base: 1, md: 2}} spacing={6} width="100%">
                        {urls.map((url, index) => (
                            <Box key={index} boxShadow="md" borderRadius="md" overflow="hidden" bg="white">
                                <Image
                                    src={url}
                                    alt={`Attachment ${index + 1}`}
                                    objectFit="contain"
                                    width="100%"
                                    maxH="500px"
                                    borderRadius="md"
                                />
                            </Box>
                        ))}
                    </SimpleGrid>
                )}
            </VStack>
        </Box>
    );
};

export default UrlPhotoView;
